import { socketService } from "@/sockets/socketService";
import { INTERNAL_CHAT_WATCH, INTERNAL_CHAT_UNWATCH } from "@/sockets/socketEvents";

/**
 * Join a lead's internal-chat LIVE room for as long as at least one chat
 * view on that lead is mounted. Ref-counted: the lead drawer chat and the
 * header chat can both sit on the same lead, and the second one closing must
 * not un-join the first. The join is a STICKY emit, so it is replayed after a
 * socket reconnect (server-side room membership dies with the socket).
 */
const refs = new Map<number, number>();

export function watchLeadChat(leadId: number): () => void {
  const id = Number(leadId);
  if (!Number.isFinite(id) || id <= 0) return () => {};
  const key = `${INTERNAL_CHAT_WATCH}:${id}`;
  const n = (refs.get(id) ?? 0) + 1;
  refs.set(id, n);
  if (n === 1) socketService.addStickyEmit(INTERNAL_CHAT_WATCH, { leadId: id }, key);

  let released = false;
  return () => {
    if (released) return;
    released = true;
    const left = (refs.get(id) ?? 1) - 1;
    if (left <= 0) {
      refs.delete(id);
      socketService.removeStickyEmit(key, INTERNAL_CHAT_UNWATCH, { leadId: id });
    } else {
      refs.set(id, left);
    }
  };
}
